export default __webpack_public_path__ + "static/media/890.5cab6211.gif";